import React from 'react';
import { Button } from './ui/button';
import { motion } from 'framer-motion';
import { mockData } from '../data/mock';

const Hero = () => {
  const { hero } = mockData;

  return (
    <section id="hero" className="relative min-h-screen flex items-center overflow-hidden" data-testid="hero-section">
      {/* Background Image */}
      <div className="absolute inset-0 z-0">
        <img 
          src="https://static.prod-images.emergentagent.com/jobs/e29e1e74-dfad-4ff0-a54e-5cee69b74787/images/cbd1f917503519ab9b24abaf12c491e19678846db88c1bc1cfd77e30b667331e.png"
          alt="Atelier Baya Couture"
          className="w-full h-full object-cover"
        />
        {/* Soft gradient overlay — keeps text legible without darkening the image */}
        <div className="absolute inset-0 bg-gradient-to-r from-[#FAFAF9] via-[#FAFAF9]/80 to-transparent" />
      </div>
      
      {/* Content */}
      <div className="relative z-10 max-w-7xl mx-auto px-6 lg:px-8 w-full py-32">
        <div className="max-w-2xl">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.2 }}
          >
            <span 
              className="text-xs tracking-[0.2em] uppercase text-[#D4AF37] font-semibold"
              style={{ fontFamily: "'Outfit', sans-serif" }}
            >
              Retouches de vêtements &amp; rideaux
            </span>
          </motion.div>

          <motion.h1
            className="mt-6 text-5xl sm:text-6xl lg:text-7xl tracking-tight leading-none font-light text-[#1C1917]"
            style={{ fontFamily: "'Playfair Display', serif" }}
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.4 }}
            data-testid="hero-title"
          >
            {hero.title}
          </motion.h1>

          <motion.p
            className="mt-6 text-lg sm:text-xl leading-relaxed text-[#57534E] max-w-lg"
            style={{ fontFamily: "'Outfit', sans-serif", fontWeight: 300 }}
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.6 }}
          >
            {hero.description}
          </motion.p>

          <motion.div
            className="mt-10 flex flex-col sm:flex-row gap-4"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.8 }}
          >
            <Button 
              onClick={() => document.getElementById('contact')?.scrollIntoView({ behavior: 'smooth' })}
              className="bg-[#D4AF37] hover:bg-[#B8962E] text-white font-medium px-8 py-6 rounded-full text-base tracking-wide shadow-lg hover:shadow-xl transition-all duration-300"
              style={{ fontFamily: "'Outfit', sans-serif" }}
              data-testid="hero-cta-btn"
            >
              {hero.cta}
            </Button>
            <Button 
              variant="outline"
              onClick={() => document.getElementById('services')?.scrollIntoView({ behavior: 'smooth' })}
              className="border-2 border-[#D4AF37]/40 text-[#1C1917] hover:bg-[#D4AF37]/10 font-medium px-8 py-6 rounded-full text-base tracking-wide transition-all duration-300"
              style={{ fontFamily: "'Outfit', sans-serif" }}
              data-testid="hero-services-btn"
            >
              Nos services
            </Button>
          </motion.div>

          {/* Trust stats */}
          <motion.div
            className="mt-16 flex gap-12"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 0.8, delay: 1.0 }}
          >
            <div>
              <div className="text-3xl font-light text-[#D4AF37]" style={{ fontFamily: "'Playfair Display', serif" }}>10+</div>
              <div className="text-sm text-[#A8A29E] mt-1" style={{ fontFamily: "'Outfit', sans-serif" }}>Années d'expérience</div>
            </div>
            <div className="w-px bg-[#E8D5D1]" />
            <div>
              <div className="text-3xl font-light text-[#D4AF37]" style={{ fontFamily: "'Playfair Display', serif" }}>500+</div>
              <div className="text-sm text-[#A8A29E] mt-1" style={{ fontFamily: "'Outfit', sans-serif" }}>Clients satisfaits</div>
            </div>
            <div className="w-px bg-[#E8D5D1]" />
            <div>
              <div className="text-3xl font-light text-[#D4AF37]" style={{ fontFamily: "'Playfair Display', serif" }}>4.9</div>
              <div className="text-sm text-[#A8A29E] mt-1" style={{ fontFamily: "'Outfit', sans-serif" }}>Note Google</div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
